import { Card, Col, Input, Row, Select, Typography } from "antd";
import { TagSelector } from "shared/components/tag/tag-selector";
import { MceEditor } from "shared/components/tinymce/mce-editor";
import { UploadFileLocal } from "shared/components/upload-file/upload-file";
import { CoreResource, t } from "shared/plugins/localization";
import { cleanUnicode } from "shared/plugins/string-helper";
import { BlogCategoryModel } from "states/blog-category/blog-category.models";
import { BlogModel } from "states/blog/blog.models";
import { TagModel } from "states/tag/tag.models";
const { Option } = Select;
export interface IBlogInformationTabProps {
  model: BlogModel;
  onChange: (newModel: BlogModel) => void;
  blogCategories: BlogCategoryModel[];
}
export function BlogInformationTab(props: IBlogInformationTabProps) {
  const { model, onChange, blogCategories } = props;
  return (
    <Row gutter={[16, 16]}>
      <Col span="16">
        <Card title={`Thông tin`}>
          <Input.Group className="mb-4">
            <Typography.Text>Tiêu đề </Typography.Text>
            <Input
              value={model.title}
              onChange={(e) => {
                onChange({
                  ...model,
                  title: e.target.value,
                  slug: cleanUnicode(e.target.value),
                  seoFields: {
                    ...model.seoFields,
                    metaTitle: e.target.value,
                  },
                });
              }}
              placeholder={`Tiêu đề`}
            ></Input>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Mô tả</Typography.Text>
            <MceEditor
              pageContent={model.description}
              onChange={(e) => {
                onChange({ ...model, description: e });
              }}
            ></MceEditor>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Nội dung</Typography.Text>
            <MceEditor
              pageContent={model.blogContent}
              onChange={(e) => {
                onChange({ ...model, blogContent: e });
              }}
            ></MceEditor>
          </Input.Group>
        </Card>
      </Col>
      <Col span="8">
        <Card title={`Ảnh đại diện`} className="mb-4">
          <UploadFileLocal
            album={model.avatar ? [model.avatar] : []}
            maxFileCount={1}
            multiple={false}
            onChange={(newFileList: string[]) => {
              onChange({ ...model, avatar: newFileList[0] });
            }}
          />
        </Card>
        <Card
          title={`Danh mục bài viết`}
          className="mb-4"
        >
          <Input.Group className="mb-4">
            <Typography.Text>Danh mục chính</Typography.Text>
            <Select
              className="w-100"
              placeholder={`Danh mục chính`}
              onChange={(item) => {
                onChange({ ...model, mainCategoryId: item });
              }}
              allowClear
              value={model?.mainCategoryId}
              showSearch
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {blogCategories &&
                blogCategories.map((cate) => (
                  <Option key={cate.id} value={cate.id}>
                    {cate.name}
                  </Option>
                ))}
            </Select>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>
            Danh mục phụ
            </Typography.Text>
            <Select
              className="w-100"
              placeholder={`Danh mục phụ`}
              onChange={(item) => {
                onChange({ ...model, relatedCategoryIds: item });
              }}
              allowClear
              value={model?.relatedCategoryIds ?? []}
              showSearch
              mode="multiple"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {blogCategories &&
                blogCategories.map((cate) => (
                  <Option key={cate.id} value={cate.id}>
                    {cate.name}
                  </Option>
                ))}
            </Select>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Tags: </Typography.Text>
            <TagSelector
              onChange={(values) => {
                values = values as TagModel[];
                onChange({
                  ...model,
                  tags: values,
                });
              }}
              isMultiple={true}
              value={model.tags ? model.tags.map((m) => m.id) : []}
            />
          </Input.Group>
        </Card>
      </Col>
    </Row>
  );
}
